export default "__VITE_ASSET__y9tT2T_H__"